import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["deleteButton"];

  deleteFavicon() {
    const faviconId = this.deleteButtonTarget.dataset.faviconId;
    const alert_message =
      "Your site’s browser icon will revert to the default setting and all customizations will be removed.";
    const dialog = $(
      `<div id='dialog-confirm' role='alert'><p>${alert_message}</p></div>`
    );

    if (!$("#dialog-confirm").length) $("body").append(dialog);

    dialog.dialog({
      dialogClass: "favicon-delete-confirmation-modal",
      resizable: false,
      modal: true,
      title: "Reset Browser Icon?",
      buttons: {
        Cancel: {
          text: "Cancel",
          click: function () {
            $(this).dialog("close");
          },
        },
        Delete: {
          text: "Reset",
          click: function () {
            $(this).dialog("close");
            $(".logo-favicon-images").animate({ opacity: 0.1 }, "fast");
            $(".image-section-loading").show();
          },
          "data-url": `/favicons/${faviconId}`,
          "data-method": "DELETE",
          "data-remote": "true",
        },
      },
    });
  }
}
